import BaseModelAPI from '../BaseModelAPI';

export default class DiSubcontDeliveryCard extends BaseModelAPI {
	static entity = 'newobject1912';
	static entityName = 'disubcontdeliverycard';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryCardNumber = '';
			this.partId = '';
			this.part = {};
			this.dcQty = 0;
			this.deliveryInstructionSubcontractDetailId = '';
			this.deliveryInstructionSubcontractDetail = {};
			this.deliveryDate = '';
			this.sequence = 0;
			this.totalDeliveryCard = 0;
			this.transactionType = '';
			this.transactionId = 0;
			this.isUsed = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}